import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initAnalytics } from "./lib/analytics";
import "./styles/m3.css";
import "./styles/landing.css";

// Boot Google Analytics if VITE_GA_ID is set. No-op otherwise.
initAnalytics();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
